import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function AiIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 26, 26);
  const a11y = resolveA11yProps(props);

  return (
    <svg
      viewBox="0 0 26 26"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      width={width}
      height={height}
      {...rest}
      {...a11y}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M10.6445 4.41509C10.9117 4.41509 11.1283 4.63473 11.1283 4.90566C11.1283 5.17659 10.9117 5.39623 10.6445 5.39623H6.28993C3.35053 5.39623 0.967681 7.8122 0.967681 10.7925V19.6226C0.967681 22.6029 3.35053 25.0189 6.28993 25.0189H14.9991C17.9385 25.0189 20.3213 22.6029 20.3213 19.6226V16.1887C20.3213 15.9177 20.5379 15.6981 20.8051 15.6981C21.0724 15.6981 21.289 15.9177 21.289 16.1887V19.6226C21.289 23.1448 18.4729 26 14.9991 26H6.28993C2.8161 26 0 23.1448 0 19.6226V10.7925C0 7.27034 2.8161 4.41509 6.28993 4.41509H10.6445Z"
        fill="#F5F5F5"
        fillOpacity={0.5}
      />
      <path
        d="M10.6445 4.41509C10.9117 4.41509 11.1283 4.63473 11.1283 4.90566C11.1283 5.17659 10.9117 5.39623 10.6445 5.39623H6.28993C3.35053 5.39623 0.967681 7.8122 0.967681 10.7925V19.6226C0.967681 22.6029 3.35053 25.0189 6.28993 25.0189H14.9991C17.9385 25.0189 20.3213 22.6029 20.3213 19.6226V16.1887C20.3213 15.9177 20.5379 15.6981 20.8051 15.6981C21.0724 15.6981 21.289 15.9177 21.289 16.1887V19.6226C21.289 23.1448 18.4729 26 14.9991 26H6.28993C2.8161 26 0 23.1448 0 19.6226V10.7925C0 7.27034 2.8161 4.41509 6.28993 4.41509H10.6445Z"
        fill="url(#paint0_linear_6439_488806)"
      />
      <path
        d="M19.0757 0.81626C19.1651 0.550634 19.5357 0.550633 19.6251 0.81626L20.2768 2.75122C20.8578 4.47604 22.1939 5.83075 23.8951 6.41975L25.8035 7.08052C26.0655 7.17123 26.0655 7.5469 25.8035 7.63761L23.8951 8.29838C22.1939 8.88738 20.8578 10.2421 20.2768 11.9669L19.6251 13.9019C19.5357 14.1675 19.1651 14.1675 19.0757 13.9019L18.424 11.9669C17.843 10.2421 16.5069 8.88738 14.8057 8.29838L12.8973 7.63761C12.6353 7.5469 12.6353 7.17123 12.8973 7.08052L14.8057 6.41975C16.5069 5.83075 17.843 4.47604 18.424 2.75122L19.0757 0.81626Z"
        fill="#F5F5F5"
        fillOpacity={0.5}
      />
      <path
        d="M19.0757 0.81626C19.1651 0.550634 19.5357 0.550633 19.6251 0.81626L20.2768 2.75122C20.8578 4.47604 22.1939 5.83075 23.8951 6.41975L25.8035 7.08052C26.0655 7.17123 26.0655 7.5469 25.8035 7.63761L23.8951 8.29838C22.1939 8.88738 20.8578 10.2421 20.2768 11.9669L19.6251 13.9019C19.5357 14.1675 19.1651 14.1675 19.0757 13.9019L18.424 11.9669C17.843 10.2421 16.5069 8.88738 14.8057 8.29838L12.8973 7.63761C12.6353 7.5469 12.6353 7.17123 12.8973 7.08052L14.8057 6.41975C16.5069 5.83075 17.843 4.47604 18.424 2.75122L19.0757 0.81626Z"
        fill="url(#paint1_linear_6439_488806)"
      />
      <path
        d="M14.4153 0.0724786C14.4478 -0.0241595 14.5826 -0.0241596 14.6152 0.0724785L14.8523 0.776442C15.0636 1.40395 15.5497 1.89681 16.1686 2.1111L16.8629 2.35149C16.9582 2.38449 16.9582 2.52117 16.8629 2.55417L16.1686 2.79456C15.5497 3.00885 15.0636 3.50171 14.8523 4.12922L14.6152 4.83318C14.5826 4.92982 14.4478 4.92982 14.4153 4.83318L14.1782 4.12922C13.9668 3.50171 13.4807 3.00885 12.8618 2.79456L12.1675 2.55417C12.0722 2.52117 12.0722 2.38449 12.1675 2.35149L12.8618 2.1111C13.4807 1.89681 13.9668 1.40395 14.1782 0.776442L14.4153 0.0724786Z"
        fill="#F5F5F5"
        fillOpacity={0.5}
      />
      <path
        d="M14.4153 0.0724786C14.4478 -0.0241595 14.5826 -0.0241596 14.6152 0.0724785L14.8523 0.776442C15.0636 1.40395 15.5497 1.89681 16.1686 2.1111L16.8629 2.35149C16.9582 2.38449 16.9582 2.52117 16.8629 2.55417L16.1686 2.79456C15.5497 3.00885 15.0636 3.50171 14.8523 4.12922L14.6152 4.83318C14.5826 4.92982 14.4478 4.92982 14.4153 4.83318L14.1782 4.12922C13.9668 3.50171 13.4807 3.00885 12.8618 2.79456L12.1675 2.55417C12.0722 2.52117 12.0722 2.38449 12.1675 2.35149L12.8618 2.1111C13.4807 1.89681 13.9668 1.40395 14.1782 0.776442L14.4153 0.0724786Z"
        fill="url(#paint2_linear_6439_488806)"
      />
      <path
        d="M10.734 17.6777C10.7027 17.6074 10.6337 17.5622 10.5576 17.5622H6.58803C6.51195 17.5622 6.44292 17.6074 6.41163 17.6777L5.64105 19.4089C5.60975 19.4792 5.54072 19.5244 5.46464 19.5244H4.72459C4.58315 19.5244 4.48948 19.3756 4.54907 19.2455L7.965 11.7889C7.99673 11.7197 8.06521 11.6754 8.14053 11.6754H9.01664C9.09188 11.6754 9.1603 11.7196 9.19207 11.7887L12.6188 19.2453C12.6786 19.3754 12.5849 19.5244 12.4434 19.5244H11.681C11.6049 19.5244 11.5359 19.4792 11.5046 19.4089L10.734 17.6777ZM9.98588 16.6651C10.1264 16.6651 10.2201 16.518 10.1623 16.3882L8.74922 13.2152C8.68066 13.0612 8.46501 13.0612 8.39644 13.2152L6.98339 16.3882C6.92556 16.518 7.01924 16.6651 7.15978 16.6651H9.98588Z"
        fill="#F5F5F5"
        fillOpacity={0.5}
      />
      <path
        d="M10.734 17.6777C10.7027 17.6074 10.6337 17.5622 10.5576 17.5622H6.58803C6.51195 17.5622 6.44292 17.6074 6.41163 17.6777L5.64105 19.4089C5.60975 19.4792 5.54072 19.5244 5.46464 19.5244H4.72459C4.58315 19.5244 4.48948 19.3756 4.54907 19.2455L7.965 11.7889C7.99673 11.7197 8.06521 11.6754 8.14053 11.6754H9.01664C9.09188 11.6754 9.1603 11.7196 9.19207 11.7887L12.6188 19.2453C12.6786 19.3754 12.5849 19.5244 12.4434 19.5244H11.681C11.6049 19.5244 11.5359 19.4792 11.5046 19.4089L10.734 17.6777ZM9.98588 16.6651C10.1264 16.6651 10.2201 16.518 10.1623 16.3882L8.74922 13.2152C8.68066 13.0612 8.46501 13.0612 8.39644 13.2152L6.98339 16.3882C6.92556 16.518 7.01924 16.6651 7.15978 16.6651H9.98588Z"
        fill="url(#paint3_linear_6439_488806)"
      />
      <path
        d="M13.9315 11.8716C13.9315 11.7632 14.0182 11.6754 14.125 11.6754H14.8723C14.9791 11.6754 15.0658 11.7632 15.0658 11.8716V19.3282C15.0658 19.4366 14.9791 19.5244 14.8723 19.5244H14.125C14.0182 19.5244 13.9315 19.4366 13.9315 19.3282V11.8716Z"
        fill="#F5F5F5"
        fillOpacity={0.5}
      />
      <path
        d="M13.9315 11.8716C13.9315 11.7632 14.0182 11.6754 14.125 11.6754H14.8723C14.9791 11.6754 15.0658 11.7632 15.0658 11.8716V19.3282C15.0658 19.4366 14.9791 19.5244 14.8723 19.5244H14.125C14.0182 19.5244 13.9315 19.4366 13.9315 19.3282V11.8716Z"
        fill="url(#paint4_linear_6439_488806)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6439_488806"
          x1={19.8375}
          y1={6.37736}
          x2={1.19773}
          y2={24.7616}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B20BFF" />
          <stop offset={1} stopColor="#0059FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6439_488806"
          x1={19.8375}
          y1={6.37736}
          x2={1.19773}
          y2={24.7616}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B20BFF" />
          <stop offset={1} stopColor="#0059FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6439_488806"
          x1={19.8375}
          y1={6.37736}
          x2={1.19773}
          y2={24.7616}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B20BFF" />
          <stop offset={1} stopColor="#0059FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6439_488806"
          x1={19.8375}
          y1={6.37736}
          x2={1.19773}
          y2={24.7616}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B20BFF" />
          <stop offset={1} stopColor="#0059FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6439_488806"
          x1={19.8375}
          y1={6.37736}
          x2={1.19773}
          y2={24.7616}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#B20BFF" />
          <stop offset={1} stopColor="#0059FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default AiIcon;
